import type { Mark, TTextLeaf } from '@/textLeaf';
import type { JSONContent } from '@tiptap/core';
import { produce } from 'immer';

export const updateMergeTagText = (node: JSONContent, newText: string) => {
  return produce(node, (draft) => {
    const content = draft.content;
    if (!content) {
      draft.content = [
        {
          type: 'text',
          text: newText,
          marks: [],
        },
      ];
      return;
    }

    // Extract all marks from text content items
    const allMarks = content
      .filter((contentItem): contentItem is TTextLeaf => contentItem?.type === 'text')
      .reduce<Mark[]>((acc, contentItem) => {
        if (contentItem.marks) {
          acc.push(...contentItem.marks);
        }
        return acc;
      }, []);

    // Merge marks by type, combining attrs
    const marksMap = allMarks.reduce<Record<string, Mark>>((acc, mark) => {
      const existingMark = acc[mark.type];
      if (existingMark?.attrs && mark.attrs) {
        acc[mark.type] = {
          type: mark.type,
          attrs: {
            ...existingMark.attrs,
            ...mark.attrs,
          },
        };
      } else {
        acc[mark.type] = mark;
      }
      return acc;
    }, {});

    const marks = Object.values(marksMap);

    draft.content = [
      {
        type: 'text',
        text: newText,
        marks,
      },
    ];
  });
};
